var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-column flex-fill" }, [
    _c(
      "div",
      {
        staticClass:
          "annotations-item panel-control-content d-flex flex-column flex-fill",
      },
      [
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "btn-toolbar w-100 justify-content-center",
                attrs: { role: "toolbar", "aria-label": "" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "btn-group btn-block",
                    attrs: { role: "group", "aria-label": "Actions" },
                  },
                  _vm._l(_vm.activeActions, function (action, key) {
                    return _c(
                      "button",
                      {
                        key: key,
                        staticClass: "btn btn-main min-w-auto mx-0",
                        attrs: {
                          disabled: action.disabled(),
                          title: action.title,
                          type: "button",
                          "data-toggle": "tooltip-city",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.applyAction(key, $event)
                          },
                        },
                      },
                      [_c("i", { class: action.icon })]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row flex-fill" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "form",
              { attrs: { autocomplete: "off", "data-vv-scope": "form" } },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            readonly: _vm.readonlyFormItem,
                            type: "text",
                            id: "input-geometryTitle",
                            name: "geometryTitle",
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("geometryTitle") },
                            ],
                            error: _vm.fnFirstError("geometryTitle"),
                          },
                          scopedSlots: _vm._u(
                            [
                              _vm.icon
                                ? {
                                    key: "grpAppend",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center px-2",
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.icon,
                                                alt: "Geometry",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : null,
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.form.geometryTitle,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "geometryTitle",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.geometryTitle",
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Título\n                                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row geometries mt-3" }, [
      _c("div", { staticClass: "col-12" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }